import React, { useState, useEffect } from 'react';
import { TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import analytics from '../../../../modules/analytics';
import { SignupCountdownText } from './SignupCountdownText';

import { HeaderText, Stack } from '../../../ui';
import { ClockThreeIcon } from '../../../ui/Icons';

export const SignupCountdownMainContent = ({ signupCutoff }) => {
  const untilCutoff = moment.duration(signupCutoff.diff(moment()));
  const [days, setDays] = useState(untilCutoff.days());
  const [hours, setHours] = useState(untilCutoff.hours());
  const [minutes, setMinutes] = useState(untilCutoff.minutes());
  const [seconds, setSeconds] = useState(untilCutoff.seconds());

  useEffect(() => {
    analytics.track('pro_profile_complete_countdown_viewed');
    const countdownTimer = setInterval(() => {
      let timer = untilCutoff;
      if (timer <= 0) {
        clearInterval(countdownTimer);
      } else {
        timer = timer.subtract(1, 's');
        setDays(timer.days());
        setHours(timer.hours());
        setMinutes(timer.minutes());
        setSeconds(timer.seconds());
      }
    }, 1000);

    return () => clearInterval(countdownTimer);
  }, []);

  return (
    <Box maxWidth="82%" paddingTop={8}>
      <TouchableOpacity
        onPress={() => analytics.track('pro_profile_complete_countdown_clicked')}
        testID="signup-countdown-container"
      >
        <HeaderText level={4} testID="signup-countdown-header">
          Spots in our search directory are limited
        </HeaderText>
        <SignupCountdownText days={days} />
        <Inline space={4} justifyContent="space-evenly" paddingTop={8}>
          <Stack alignItems="center">
            <HeaderText testID="signup-countdown-days">{days}</HeaderText>
            <HeaderText
              level={3}
              color={colors.ash}
              testID="signup-countdown-days-label"
            >
              {`DAY${days === 1 ? '' : 'S'}`}
            </HeaderText>
          </Stack>
          <Stack alignItems="center">
            <HeaderText testID="signup-countdown-hours">{hours}</HeaderText>
            <HeaderText level={3} color={colors.ash}>
              HOURS
            </HeaderText>
          </Stack>
          <Stack alignItems="center">
            <HeaderText testID="signup-countdown-minutes">{minutes}</HeaderText>
            <HeaderText level={3} color={colors.ash}>
              MIN
            </HeaderText>
          </Stack>
          <Stack alignItems="center">
            <HeaderText testID="signup-countdown-seconds">{seconds}</HeaderText>
            <HeaderText level={3} color={colors.ash}>
              SEC
            </HeaderText>
          </Stack>
        </Inline>
      </TouchableOpacity>
    </Box>
  );
};

SignupCountdownMainContent.propTypes = {
  signupCutoff: PropTypes.object.isRequired,
};

SignupCountdownMainContent.defaultProps = {};

export const SignupCountdownSideContent = () => (
  <Box padding={16} testID="signup-countdown-icon">
    <ClockThreeIcon />
  </Box>
);
